import {
  AboutPage,
  CareerDetailsPage,
  CareersPage,
  ChangePassword,
  ContactPage,
  Customer,
  CustomerDetails,
  CustomerLeadsPage,
  CustomerNew,
  FAQPage,
  ForgotPassword,
  JoinPage,
  LandingPage,
  Login,
  MagicLogin,
  MerchPage,
  ProjectDetailsPage,
  ProjectsPage,
  QuotePage,
  ServicesPage,
  SettingsPage,
  TalentPoolPage,
  UsersPage,
} from "@components/pages";
import { ProductDetailPage } from "@components/pages/ProductDetailPage";
import { OrderSuccessPage } from "@components/pages/OrderSuccessPage";
import { OrderPage } from "@components/pages/OrderPage";
import { ProductsManagementPage } from "@components/pages/ProductsManagementPage";
import { OrdersManagementPage } from "@components/pages/OrdersManagementPage";
import { Navigate, Route, Routes } from "react-router-dom";
import { PrivateTemplate, PublicTemplate } from "./@components/templates";

function App() {
  return (
    <Routes>
      <Route path="/" element={<PublicTemplate />}>
        <Route index element={<LandingPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="services" element={<ServicesPage />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="projects/:projectId" element={<ProjectDetailsPage />} />
        <Route path="careers" element={<CareersPage />} />
        <Route path="talent-pool" element={<TalentPoolPage />} />
        <Route path="customer-leads" element={<CustomerLeadsPage />} />
        <Route path="careers/:positionId" element={<CareerDetailsPage />} />
        <Route path="faq" element={<FAQPage />} />
        <Route path="join" element={<JoinPage />} />
        <Route path="merch" element={<MerchPage />} />
        <Route path="merch/:id" element={<ProductDetailPage />} />
        <Route path="order-success" element={<OrderSuccessPage />} />
        <Route path="orders/:orderId" element={<OrderPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="quote" element={<QuotePage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="users/:userId" element={<UsersPage />} />
        <Route path="products" element={<ProductsManagementPage />} />
        <Route path="orders-management" element={<OrdersManagementPage />} />
      </Route>
      <Route path="/app" element={<PrivateTemplate />}>
        <Route index element={<Navigate to="/app/clientes" replace />} />
        <Route path="clientes/">
          <Route index element={<Customer />} />
          <Route path="novo" element={<CustomerNew />} />
          <Route path=":customerId" element={<CustomerDetails />} />
        </Route>
        <Route path="configuracoes" element={<SettingsPage />} />
        <Route path="products" element={<ProductsManagementPage />} />
        <Route path="orders" element={<OrdersManagementPage />} />
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="/magic-login" element={<MagicLogin />} />
      <Route path="/reset-password" element={<ChangePassword />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
    </Routes>
  );
}

export default App;
